import { templatePlaceholders } from "../constants";
const clientFirstNamePlaceholder = new RegExp(templatePlaceholders.clientFirstName, 'g');
const vendorBusinessNamePlaceholder = new RegExp(templatePlaceholders.vendorBusinessName, 'g');
export function replacePlaceholders(introductoryMessage, clientFirstName, vendorBusinessName) {
  return introductoryMessage ? introductoryMessage.replace(clientFirstNamePlaceholder, clientFirstName).replace(vendorBusinessNamePlaceholder, vendorBusinessName) : '';
}